// activity_pdf.source doubles as the interactive worksheet flag. It is free text
// and has been saved with stray trailing whitespace, so always compare trimmed.
export const INTERACTIVE_SOURCE = "interactive"

export const isInteractiveSource = source =>
  String(source == null ? "" : source)
    .trim()
    .toLowerCase() === INTERACTIVE_SOURCE
